"use strict";

// Fonction utilitaire qui retourne une promesse qui se résout après un setTimeout avec une durée déterminée
// Ex: wait(duration en millisecondes).then(function() {
// 	do something...
// });
function wait(duration) {
	return new Promise(function(resolve) {
		setTimeout(resolve, duration);
	});
}

function debounce(callback, delay) {
	let timeout = null;

	return function() {
		clearTimeout(timeout);

		timeout = setTimeout(function() {
			callback();
		}, delay);
	};
}

/**
 *    ######## #### ##       ######## ######## ########   ######  
 *    ##        ##  ##          ##    ##       ##     ## ##    ## 
 *    ##        ##  ##          ##    ##       ##     ## ##       
 *    ######    ##  ##          ##    ######   ########   ######  
 *    ##        ##  ##          ##    ##       ##   ##         ## 
 *    ##        ##  ##          ##    ##       ##    ##  ##    ## 
 *    ##       #### ########    ##    ######## ##     ##  ######  
 */
function filterProducts() {
	const productsContainer = $('.all-products-ctn');
	const productsWrapper = productsContainer.find('.all-products').get(0);

	if (!productsWrapper) return;

	const searchTerm = $('#search-input').val().toLowerCase().trim();
	const activeFilters = getActiveFilters();

	productsContainer.addClass('--loading');
	productsWrapper.classList.add('--transitioning');

	wait(600).then(function() {
		animateProductsContainerHeight(function() {

			let visibleProductsCount = 0;
			const hasActiveFilters = Object.keys(activeFilters).length > 0;

			$('.products-grid .product-card').each(function() {
				const product = this;
				const title = $(product).find('.title').text().toLowerCase();

				const searchMatch =
					searchTerm === '' ||
					title.includes(searchTerm);

				let categoryMatch = true;

				if (hasActiveFilters) {
					categoryMatch = Object.entries(activeFilters).every(function([filterName, selectedValues]) {
						const productValue = product.dataset[filterName];

						return productValue &&
							selectedValues.includes(productValue);
					});
				}

				const isVisible = searchMatch && categoryMatch;

				if (isVisible) {
					product.classList.remove('--hidden');
					visibleProductsCount++;
				} else {
					product.classList.add('--hidden');
				}
			});

			const productsGrid = $('.products-grid');

			if (visibleProductsCount === 0) {
				productsGrid.addClass('--hidden');
				$('.no-products').addClass('--is-visible');
			} else {
				productsGrid.removeClass('--hidden');
				$('.no-products').removeClass('--is-visible');
			}
		});
	});

	wait(1200).then(function() {
		productsContainer.removeClass('--loading');
		productsWrapper.classList.remove('--transitioning');
	});
}

function getActiveFilters() {
	const filters = {};

	$('.module-categories-filters .checkbox-group input:checked').each(function() {
		const filterName = this.dataset.filter;
		const filterValue = this.value;

		if (!filterName || !filterValue || filterValue === 'all') {
			return;
		}

		if (!filters[filterName]) {
			filters[filterName] = [];
		}

		filters[filterName].push(filterValue);
	});

	return filters;
}

// Animation de la hauteur du conteneur des produits
function animateProductsContainerHeight(callback) {
	const container = document.querySelector('.all-products-ctn');
	const content = document.querySelector('.all-products');

	if (!container || !content) {
		if (typeof callback === 'function') callback();
		return;
	}

	// Nettoie une transition précédente
	container.style.transition = 'none';
	container.style.height = container.offsetHeight + 'px';

	// Force repaint
	container.offsetHeight;

	// Remet la transition
	container.style.transition = 'height 0.4s ease';

	if (typeof callback === 'function') callback();

	const endHeight = content.scrollHeight;

	requestAnimationFrame(function() {
		container.style.height = endHeight + 'px';
	});

	const onTransitionEnd = function(event) {
		if (event.propertyName !== 'height') return;

		container.style.height = 'auto';
		container.removeEventListener('transitionend', onTransitionEnd);
	};

	container.addEventListener('transitionend', onTransitionEnd);

	wait(1200).then(function() {
		container.style.height = 'auto';
	});
}

const debouncedFilterProducts = debounce(function() {
	filterProducts();
}, 300);

/**
 *                                                                                                                            
 *     ###### # #      ##### ###### #####     #####  #   #     ####    ##   ##### ######  ####   ####  #####  # ######  ####  
 *     #      # #        #   #      #    #    #    #  # #     #    #  #  #    #   #      #    # #    # #    # # #      #      
 *     #####  # #        #   #####  #    #    #####    #      #      #    #   #   #####  #      #    # #    # # #####   ####  
 *     #      # #        #   #      #####     #    #   #      #      ######   #   #      #  ### #    # #####  # #           # 
 *     #      # #        #   #      #   #     #    #   #      #    # #    #   #   #      #    # #    # #   #  # #      #    # 
 *     #      # ######   #   ###### #    #    #####    #       ####  #    #   #   ######  ####   ####  #    # # ######  ####  
 *                                                                                                                            
 */
$('.module-categories-filters .checkbox-group input').on('change', filterProducts);
$('#search-input').on('keyup', debouncedFilterProducts);

$(document).ready(function() {
	const categoriesFilter = $('.module-categories-filters');
	const firstFilter = $(categoriesFilter).find('.category-group').get(0);
	firstFilter.classList.add('--is-open');

	// Si on arrive du lien motoneige du sous-menu des remorques, on filtre déjà par remorque fermée de type motoneige
	if (window.location.search === '?type=motoneige') {
		const typeFilters = $(categoriesFilter).find('input[data-filter="type"]');
		
		typeFilters.each(function() {
			const filter = $(this).get(0);
			console.log(filter.value);
			
			if (filter.value === '2') {
				filter.checked = true;
				filterProducts();
			}
		})
		
		// Si le smooth scroll a été instancié, on scroll vers la section des remorques filtrés par le type motoneige
		setTimeout(() => {
			if (window.lenis) {
				const offset = -document.querySelector('.module-menu .menu-navbar').offsetHeight - 4 || 0;
	
				lenis.scrollTo(document.querySelector('.top-actions'), {
					offset: offset,
					duration: 1.2,
					immediate: false
				});
			}
		}, 500);
	}

    /**
 	*                                              
	*     #####  ####   ####   ####  #      ###### 
	*       #   #    # #    # #    # #      #      
	*       #   #    # #      #      #      #####  
	*       #   #    # #  ### #  ### #      #      
	*       #   #    # #    # #    # #      #      
	*       #    ####   ####   ####  ###### ###### 
	*                                              
	*/
	// Module tiroir des filtres
	const toggleElements = ['.open-filters', '.close-filters', '.filters-backdrop'];
	toggleElements.forEach(element => {
		document.querySelector(element).addEventListener('click', () => {
			 $(categoriesFilter).toggleClass("--is-open");
		});
	});
 
	// Accordéons des filtres avec leurs options
	$('.category-header').on("click", function() {
		const category = $(this).closest('.category-group');
		$(category).toggleClass('--is-open');
	})

	/**
	 *                                               
	 *      ####  ######   ##   #####   ####  #    # 
	 *     #      #       #  #  #    # #    # #    # 
	 *      ####  #####  #    # #    # #      ###### 
	 *          # #      ###### #####  #      #    # 
	 *     #    # #      #    # #   #  #    # #    # 
	 *      ####  ###### #    # #    #  ####  #    # 
	 *                                               
	 */
    // $("#search-input").on("keyup", function() {
    //  	const searchTerm = $(this).val().toLowerCase().trim();
	// 	let visibleProductsCount = 0;

	// 	// Retire tous les filtres actifs avant d'afficher les résultats de la recherche
	// 	const selectedFilters = $('.module-categories-filters .checkbox-group input:checked');
	// 	if (selectedFilters.length != 0) {
	// 		$(selectedFilters).each(function() {
	// 			const filter = $(this).get(0);
	// 			filter.checked = false;
	// 		});
	// 	}

	// 	// Pour chaque produit, si la valeur de recherche correspond au titre du produit, on retire la classe d'état --hidden
	// 	$(".products-grid .product-card").each(function() {
	// 		const title = $(this).find(".title").text().toLowerCase();

	// 		if (title.includes(searchTerm)) {
	// 			$(this).removeClass("--hidden invisible");
	// 			visibleProductsCount++;
	// 		} else {
	// 			$(this).addClass("--hidden");
	// 		}
	// 	});

	// 	// Gestion de l'affichage de la grille des produits si aucun produits ne correspond aux filtres sélectionnés
	// 	const productsGrid = $('.products-grid');
	// 	const products = $(productsGrid).find(".product-card");
	// 	const visibleProductsInCategory = products.not(".--hidden").length;

	// 	if (visibleProductsInCategory === 0) {
	// 		productsGrid.addClass("--hidden");
	// 	} else {
	// 		productsGrid.removeClass("--hidden");
	// 	}

	// 	if (visibleProductsCount === 0) {
	// 		$(".no-products").addClass("--is-visible");
	// 	} else {
	// 		$(".no-products").removeClass("--is-visible");
	// 	}
    // });
});